/**
 * Admin panel: Site Sections - turn learner-facing sections on/off per organisation.
 * Reuses TenantFeatureManagement (organizations.feature_flags). Platform admins can pick any org.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LayoutGrid } from 'lucide-react';
import TenantFeatureManagement from './TenantFeatureManagement';
import { useAuth } from '../../contexts/AuthContext';
import { API_BASE } from '../../config/api';

const API = `${API_BASE}/api`;

export default function SiteSectionsTab({ token, isPlatformAdmin }) {
  const { user } = useAuth();
  const ownOrg = user?.organization_id || 'org_navigate_master';
  const [orgs, setOrgs] = useState([]);
  const [orgId, setOrgId] = useState(ownOrg);

  useEffect(() => {
    if (!isPlatformAdmin) return;
    axios.get(`${API}/master/organizations`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setOrgs(res.data?.organizations || res.data || []))
      .catch(() => setOrgs([]));
  }, [isPlatformAdmin, token]);

  const current = orgs.find((o) => o.org_id === orgId);

  return (
    <div className="space-y-5" data-testid="site-sections-tab">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className="font-heading text-2xl font-bold text-white flex items-center gap-2"><LayoutGrid className="h-6 w-6 text-navigate-gold" /> Site Sections</h2>
        {isPlatformAdmin && orgs.length > 0 && (
          <select value={orgId} onChange={(e) => setOrgId(e.target.value)} className="h-10 rounded-md bg-zinc-900 border border-zinc-700 text-white px-2 text-sm" data-testid="site-sections-org-select">
            {orgs.map((o) => <option key={o.org_id} value={o.org_id}>{o.name}{o.org_id === 'org_navigate_master' ? ' (master - applies to all learners and visitors)' : ' (can only turn extra sections off)'}</option>)}
          </select>
        )}
      </div>
      <TenantFeatureManagement token={token} organizationId={orgId} organizationName={current?.name || (orgId === ownOrg ? 'your organisation' : orgId)} />
    </div>
  );
}
